import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { XhrService } from '@blaze-shared/platform-data-access';

import { MapSettingsInfo } from './map.models';

@Injectable({
  providedIn: 'root',
})
export class MapApiService {
  private readonly xhrService = inject(XhrService);

  getApiKey(accountId: string): Observable<MapSettingsInfo> {
    return this.xhrService.get<MapSettingsInfo>(`maps/settings`, {
      accountId,
    });
  }
}
